import type { RouteObject } from 'react-router-dom';

import { LoginCallback, LogoutRoute } from '@myphx-engineering/auth/client';

import routes from '../app-routes';

// These routes live outside AppRoot so PatientProvider never mounts on them.
// AuthProvider and GraphQLProvider are still available because they wrap the
// entire router in index.tsx.
const authRoutes: RouteObject[] = [
    {
        path: routes.loginCallback.root,
        element: <LoginCallback />,
    },
    {
        path: routes.logout,
        element: <LogoutRoute returnUrl={routes.root} />,
    },
];

export default authRoutes;
